// src/utils/apis/product/api.js
import { getData } from "../../api";

export async function GET(path) {
  return await getData(path);
}